import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { NavLink } from 'react-router-dom';
import { Flex } from 'lib/components/Flex';

export const MenuBar = styled(Flex)`
    flex: 1;
    font-family: ${(p) => p.theme.font.regular};
    background: ${(p) => p.theme.color.grayDark};
    padding: 0 ${(p) => p.theme.size.medium};
    min-height: 32px;
    max-height: 32px;
    @media (max-width: ${(p) => p.theme.breakpoint.tablet}px) {
        min-height: 48px;
        max-height: 48px;
    }
`;

const menuBarItemStyles = ({ theme }) => css`
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: ${theme.fontSize.small};
    @media (max-width: ${theme.breakpoint.medium}px) {
        font-size: ${theme.fontSize.extraSmall};
    }
    padding: 0 ${theme.size.mediumLarge};
    color: ${theme.color.white};
    text-transform: uppercase;
`;

export const MenuBarItem = styled(Flex)`
    ${menuBarItemStyles};
`;

export const MenuBarLink = styled(MenuBarItem)`
    ${menuBarItemStyles};
    &.active {
        background-color: ${(p) => p.theme.color.ReportsMenuSelected};
    }
    &:hover {
        color: ${(p) => p.theme.color.white};
    }
`.withComponent(NavLink);
